module.exports = __webpack_public_path__ + "static/img/g2.f640c04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/g2.jpg
// module id = CO9P
// module chunks = 2